// extracted by mini-css-extract-plugin
module.exports = {"box":"ThankYou_box__L4QmX"};